import React from 'react'
import classNames from 'classnames'
import DateTimeWarning from '@apiEnabler/ob-common/lib/view/DateTimeWarning'
import { formatStatus } from '@apiEnabler/ob-common/lib/biometric-consents'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'

import PageHeader from './PageHeader'
import NavBar from './NavBar'
import { PERMISSION_LABELS } from '../mortgages'

import style from './Mortgages.module.scss'

export default function Mortgages({ mortgages }) {
  return (
    <section className="js-hbo-mortgage-consent-list">
      <PageHeader
        navbar={<NavBar />}
        title="Mortgages"
        subtitle="Mortgage data being shared with third parties"
      />
      <div className={style.sections}>
        {mortgages.size ? (
          <React.Fragment>
            <table
              className={classNames(
                style.responsiveTable,
                'zb-table zb-full-width'
              )}
            >
              <thead>
                <tr>
                  <th className="js-created-on-heading">Created on</th>
                  <th className="js-tpp-name-heading">Service Provider</th>
                  <th className="js-permissions-heading">Permissions</th>
                  <th className="js-accounts-heading">
                    Mortgage account number
                  </th>
                  <th className="js-status-heading">Status</th>
                </tr>
              </thead>
              <tbody>
                {mortgages.map((consent, index) => (
                  <tr key={index} className={`js-consent-row-${index}`}>
                    <td
                      data-label="Created on"
                      className="js-created-on-heading"
                    >
                      {formatDate(
                        consent.get('createdAt'),
                        'DD MMM YYYY HH:mm'
                      )}
                    </td>
                    <td
                      data-label="Service provider"
                      className="js-tpp-name-text"
                    >
                      {consent.get('clientDisplayName')}
                    </td>
                    <td
                      data-label="Permissions"
                      className="js-permissions-text"
                    >
                      {consent
                        .getIn(['payload', 'permissions'], [])
                        .map(toPermissionLabel)
                        .join(', ')}
                    </td>
                    <td
                      data-label="Mortgage account number"
                      className={classNames(
                        style.accountCell,
                        'js-accounts-text'
                      )}
                    >
                      {consent
                        .getIn(['payload', 'mortgageAccountNumbers'], [])
                        .join(', ')}
                    </td>
                    <td data-label="Status" className="js-status-text">
                      {formatStatus(
                        consent.get('grouping', consent.get('status'))
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <DateTimeWarning />
          </React.Fragment>
        ) : (
          <span className={classNames(style.card, 'js-no-consents-msg')}>
            No service providers connections
          </span>
        )}
      </div>
    </section>
  )
}

function toPermissionLabel(permision) {
  return PERMISSION_LABELS[permision] || permision
}
